import { parseCompetenceDate } from '@utils/dates/parseCompetenceDate'

type PeriodSource = Record<string, unknown> | null | undefined
type FiliData = { startPeriod?: string; endPeriod?: string } | null | undefined

const getPeriodStr = (obj: PeriodSource, ...keys: string[]) => {
  if (!obj) return null
  for (const k of keys) {
    const snake = k.replace(/([A-Z])/g, '_$1').toLowerCase()
    const v = (obj[k] ?? obj[snake]) as string | undefined
    if (v != null && String(v).trim() !== '') return String(v).trim()
  }
  return null
}

/**
 * Retorna minDate e maxDate do período da competência a partir de uma fonte (cliente) ou do filiData.
 * Mesma lógica usada no modal "Adicionar um outro serviço" para restringir o campo Data.
 */
export const getCompetencePeriodFromSource = (
  periodSource: PeriodSource,
  filiData?: FiliData
): { minDate: Date | undefined; maxDate: Date | undefined } => {
  if (periodSource != null) {
    const minStrA = getPeriodStr(periodSource, 'fatPeriodoInicio')
    const minStrB = getPeriodStr(periodSource, 'fatDataInicio')
    const min = parseCompetenceDate(minStrA) ?? parseCompetenceDate(minStrB) ?? undefined
    const max = parseCompetenceDate(getPeriodStr(periodSource, 'fatPeriodoFim')) ?? undefined
    return { minDate: min ?? undefined, maxDate: max ?? undefined }
  }
  const minDate = filiData?.startPeriod ? (parseCompetenceDate(filiData.startPeriod) ?? undefined) : undefined
  const maxDate = filiData?.endPeriod ? (parseCompetenceDate(filiData.endPeriod) ?? undefined) : undefined
  return { minDate, maxDate }
}
